<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Goods/index.html')">商品管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>在售商品</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="名称/编码">
				<el-input v-model="item.name" placeholder="请输入商品名称或编码" size="small"></el-input>
			</el-form-item>

			<el-form-item label="商品分类">
				<el-cascader v-model="item.supplier_category_id" placeholder="请选择"
					:options="optionsProduct" :props="filterProps" clearable></el-cascader>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
<!--				<el-button type="primary" @click="excelOut" size="medium">批量导入</el-button>-->
				<el-button type="primary" @click="excelOut" size="medium">批量导出</el-button>
			</el-form-item>
		</el-form>

		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['supplier/product/add']">添加商品</el-button>
			<el-button type="danger" size="small" @click="downer" v-auth="['supplier/product/downer']">批量下架</el-button>
		</div>
		<el-table :data="list" border @selection-change="handleSelectionChange">
			<!--			这里 prop scope传值-->
			<el-table-column type="selection" align="center"></el-table-column>
			<!-- <el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column> -->
			<el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
			<el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column label="商品编码">
				<template slot-scope="scope">
					{{scope.row.sku_no}}
				</template>
			</el-table-column>
			<el-table-column label="商品图片">
				<!--				商品的组件和插槽-->
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.product_pic_main" height="30" style="display: flex; margin-right: 5px;" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="suppliercategory" label="商品分类">
				<template slot-scope="scope" v-if="scope.row.suppliercategory">
					{{scope.row.suppliercategory.name}}
				</template>
			</el-table-column>
			<el-table-column label="金额" align="center" width="160">
				<template slot-scope="scope">
					<div>
						最低：￥{{scope.row.price_min}}
					</div>
					<div>
						最高：￥{{scope.row.price_max}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center">
				<!--			价格模板插槽	-->
				<template slot-scope="scope">
					<el-tag size="small" type="success" v-if="scope.row.is_marketable">
						已上架
					</el-tag>
					<el-tag size="small" type="danger" v-else>
						已下架
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="添加时间" align="center"></el-table-column>
			<el-table-column prop="last_modified_date" label="更新时间" align="center"></el-table-column>
			<el-table-column label="操作" width="380" align="center">
				<template slot-scope="scope">
					<!--					传ID过去修改-->
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['supplier/product/edit']">查看</el-button>
					<el-popconfirm title="您确定要下架吗？"
						@confirm="changeMarke(scope.row.id)" class="l10">
						<el-button size="mini" type="warning" slot="reference">下架</el-button>
					</el-popconfirm>
					<el-button style="margin-left: 10px;" size="mini" type="primary"
							   @click="changePrice(scope.row.id,scope.row.name)" v-auth="['supplier/product/edit']">修改价格</el-button>

					<!-- 					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm> -->
					<el-popconfirm title="您确定要推送API吗？"
						@confirm="openApi(scope.row.id)" class="l10" v-if="scope.row.is_openapi==0">
						<el-button size="mini" type="warning" slot="reference">推送API</el-button>
					</el-popconfirm>
					<el-popconfirm title="您确定要下架API吗？"
						@confirm="closeApi(scope.row.id)" class="l10"  v-else>
						<el-button size="mini" type="primary" slot="reference">下架API</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!--		页码-->
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	let searchname,search_supplier_category_id;
	export default {
		name: 'Menu',
		data() {
			return {
				// 商品数据
				list: [],
				isLoad: false,
				pageNum: 0,
				pageSize: 20,
				total: 0,
				page: 1,
				thumb: [],
				// 查询
				item: {},
				optionsShop: [],
				optionsProduct: [],
				multipleSelection:[],
				filterProps: {
					value: 'id',
					label: 'name',
					emitPath: false,
					checkStrictly: true
				},
			}
		},
		beforeRouteEnter(to, from, next) {
		    searchname= from.params.searchname;
			search_supplier_category_id=from.params.search_supplier_category_id
		    next();
		},
		created() {
			this.item = {
					page: this.page,
					limit: this.pageSize,
					is_marketable: true,
					name:searchname,
					supplier_category_id:search_supplier_category_id
			},
			this.getData()
			this.loadList()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			getData() {
				// 获取商品分类
				this.axios.get('/supplier/data/getCategoryTreeSupplier', {}).then(res => {
					this.optionsProduct = res.data.tree
				})
			},
			// 获取数据
			loadList() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				//	将页码传到/Goods/index
				this.axios.post('/supplier/product/listOnSale', this.item)
					.then(res => {
						this.isLoad = !this.isLoad
						// 后端返回的商品数据列表
						this.list = res.data.list.data
						this.total = res.data.list.total
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			openApi(id){
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.post('/supplier/product/openApi', {
					id: id,
					is_openapi: 1
				}).then(res => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '操作成功',
						showClose: false
					});
					// 重新获取数据
					this.loadList()
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			closeApi(id){
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.post('/supplier/product/openApi', {
					id: id,
					is_openapi: 0
				}).then(res => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '操作成功',
						showClose: false
					});
					// 重新获取数据
					this.loadList()
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			changeMarke(id) {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.post('/supplier/product/putonORoff', {
					id: id,
					is_marketable: false
				}).then(res => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '操作成功',
						showClose: false
					});
					// 重新获取数据
					this.loadList()
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			changePrice(id,name) {
				this.$router.push({
					path: '/Goods/price.html',
					query: {
						id: id,
						name:name
					}
				});
			},
			add() {
				this.$router.push({
					path: '/Goods/add.html'
				});
			},
			//批量下架
			downer() {
			    let id = []
			    for (let key in this.multipleSelection) {
			        let item = this.multipleSelection[key]
			        id.push(item.id)
			    }
			    if (id.length == 0) {
			        this.$message.error({
			            message: '请选择商品',
			            showClose: false
			        });
			        return false;
			    }

			    if (this.isLoad) {
			        return false;
			    }

			    this.isLoad = !this.isLoad
			    this.axios.delete('/supplier/product/downer', {
			        data: {id: id, in_store: 0}
			    }).then(() => {
			        this.isLoad = false
			        this.$message.success({
			            message: '下架成功',
			            showClose: false
			        });
			        this.loadList()
			    })
			    .catch(() => {
			        this.isLoad = false
			    })
			},
			handleSelectionChange(val) {
			    this.multipleSelection = val;
			},
			// 带着商品ID跳转
			edit(id) {
				this.$router.push({
					path: '/Goods/edit.html',
					query: {
						id: id,
						op: 1,
						name:this.item.name,
						supplier_category_id:this.item.supplier_category_id
					}
				});
			},
			//sizeReload 共多少条为一页
			sizeReload(val) {
				this.pageSize = val
				this.item = {
						page: this.page,
						limit: this.pageSize,
						is_marketable: true
				},
				this.getData()
				this.loadList()
			},
			// 前往第几页
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				// 页数跳回
				this.pageNum = 1
				// 内容是在第一页的内容
				this.item.page = 1
				if(this.item.name!==undefined){
					console.log(this.item.name)
				}
				if(this.item.supplier_category_id){
					console.log(this.item.supplier_category_id)
				}
				this.loadList()
			},
			// 导出
			excelOut() {
				if (this.isLoad) {
					return false
				}

				this.isLoad = !this.isLoad
				setTimeout(function () {
					this.isLoad = false
				}.bind(this), 100000);
				this.axios.post('/supplier/product/listOnSaleExport', this.item)
						.then(res => {
							this.isLoad = false
							if (res.code == 1) {
								import('@/vendor/Export2Excel.js').then(excel => {
									var expCellName = res.data.expCellName
									var tHeader = []
									var filterVal = []
									for (var i in expCellName) {
										tHeader.push(expCellName[i])
										filterVal.push(i)
									}
									const expTableData = res.data.expTableData
									const data = this.formatJson(filterVal, expTableData)
									var d = new Date()
									var year = d.getFullYear()
									var month = d.getMonth()
									var date = d.getDate()
									var hour = d.getHours()
									var minute = d.getMinutes()
									var second = d.getSeconds()
									month = month < 10 ? '0' + month : month
									date = date < 10 ? '0' + date : date
									hour = hour < 10 ? '0' + hour : hour
									minute = minute < 10 ? '0' + minute : minute
									second = second < 10 ? '0' + second : second
									excel.export_json_to_excel({
										header: tHeader,
										data,
										filename: '在售商品列表_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
										autoWidth: this.autoWidth,
										bookType: this.bookType
									})
								})
							} else {
								this.$message({
									message: res.msg,
									type: 'error',
									duration: 3 * 1000
								})
							}
						})
			},
			formatJson (filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => {
					return v[j]
				}))
			},
		}
	}
</script>
<style scoped>
</style>
